import { createSvgIcon } from "@mui/material";

export const AlignBottomIcon = createSvgIcon(
  <svg viewBox="0 0 9 14" fill="none">
    <path
      fill="currentColor"
      d="M4.219 0c.35 0 .633.283.633.633V12h2.953a.61.61 0 0 1 .633.633.625.625 0 0 1-.633.633H.633A.64.64 0 0 1 0 12.633c0-.37.29-.633.633-.633h2.953V.633c0-.35.283-.633.633-.633"
    />
  </svg>,
  "AlignBottomIcon",
);
